export default __webpack_public_path__ + "assets/images/010c96667ef605c6c8980a0fe4b473dd.jpg";